import { useIsOnActiveSlide } from '@ad-lucy/hooks';
import type { ReactElement } from 'react';

type ExtraInfoType = {
  isOnActivePage?: boolean;
};

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function withSwiperPage<P>(WrappedComponent: React.ComponentType<P & ExtraInfoType>): any {
  const ComponentWithPageInfo = (props: P): ReactElement => {
    const isActive = useIsOnActiveSlide();
    return <WrappedComponent {...props} isOnActivePage={isActive} />;
  };
  ComponentWithPageInfo.displayName = WrappedComponent.displayName;
  return ComponentWithPageInfo;
}
